import Loader from "../../../components/Loader";
import { I18n, T } from '../../../utils/I18n/I18n';
import React, { useEffect } from 'react';
import useSetBillingAddress from "../../../hooks/useSetBillingAddress";

const CheckoutAddressesList = ({
    addresses,
    billingAddress,
    selectedAddress,
    isBusiness,
    setSelectedAddress,
    setShowAddNewAddress,
    setShowAddressList,
    setBillingType,
}) => {
    const { setBillingAddress, loading: billingLoading } = useSetBillingAddress();

    const addressHandler = (value) => {
        setSelectedAddress(value);

        if (value === "addAddress") {
            setShowAddNewAddress(true);
        } else {
            setShowAddNewAddress(false);
        }
    };

    const onConfirmHandler = async () => {
        try {
            await setBillingAddress({ customerAddressId: +selectedAddress });
            setShowAddressList(false);
        } catch (err) {
            console.error(err);
        }
    };

    const filter = ({ company }) => isBusiness ? company : !company;

    const mapper = ({ company, vat_id, firstname, lastname, street, postcode, country_id, country_code, city, telephone, id }) => (
        <option selected={billingAddress && billingAddress.id === id} className="checkout-address-list__option" key={id} value={id}>
            {company ? `${company} ${vat_id}, ` : ""}
            {`${firstname} ${lastname}, ${street[0]}, ${city} ${postcode}`}
            {`, ${(country_code === "HR" ? "Hrvatska" : country_code) || country_id}, ${telephone}`}
        </option>
    );

    const onExitHandler = () => {
        setShowAddressList(false);
        if (billingAddress && billingAddress.company) {
            setBillingType(2); // TYPE_BUSINESS
        } else {
            setBillingType(1); // TYPE_PRIVATE
        }
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        if (selectedAddress === 'addAddress') {
            setShowAddNewAddress(true);
            return;
        }

        const addressId = billingAddress && +billingAddress.customer_address_id;
        const savedAddress = addresses && addresses.find(({ id }) => id === addressId);

        if (isBusiness) {
            const firstWithCompany = savedAddress && savedAddress.company ? savedAddress
                : addresses && addresses.find(({ company }) => company);

            const newSelectedAddress = firstWithCompany && firstWithCompany.id || 'addAddress';
            setSelectedAddress(newSelectedAddress);
            if (newSelectedAddress === 'addAddress') {
                setShowAddNewAddress(true);
            }
        } else {
            const firstWithoutCompany = savedAddress && !savedAddress.company ? savedAddress
                : addresses && addresses.find(({ company }) => !company);

            const newSelectedAddress = firstWithoutCompany && firstWithoutCompany.id || 'addAddress';
            setSelectedAddress(newSelectedAddress);
            if (newSelectedAddress === 'addAddress') {
                setShowAddNewAddress(true);
            }
        }
    }, [isBusiness]);

    return (
        <div>
            <select className="checkout-address-list" onChange={e => addressHandler(e.target.value)} value={selectedAddress}>
                {addresses && addresses.filter(filter).map(mapper)}

                <I18n>
                    {t => (
                        <option value="addAddress" className="checkout-address-list__add-address">
                            {t("address.addAddress")}
                        </option>
                    )}
                </I18n>
            </select>

            {selectedAddress && selectedAddress !== 'addAddress' && (
                billingLoading ? <div className="mt-12"><Loader height="xl" /></div> : (
                    <div className="checkout-address-item__new-address__buttons">
                        {billingAddress && (
                            <button className="checkout__main__form__button exit" onClick={onExitHandler}>
                                <T id="address.exit" />
                            </button>
                        )}

                        <button className="checkout__main__form__button" onClick={onConfirmHandler}>
                            <T id="address.confirm" />
                        </button>
                    </div>
                )
            )}
        </div>
    );
};

export default CheckoutAddressesList;